import { FeaturePermissionMatrix, MenuItemData } from '@/apis/types';

/**
 * Retrieves permissions for a specific menu item or sub-menu item
 *
 * @param menu - Array of menu items with permissions
 * @param parentName - Name of the parent menu item
 * @param childName - Optional name of the child menu item
 * @returns Array of permissions or null if not found
 */
// TODO: this should be replaced with getMenuPermissions functions
export const getPermissions = (
  menu: MenuItemData[] = [],
  parentName = '',
  childName = ''
): FeaturePermissionMatrix | null => {
  if (!menu.length || !parentName) return null;

  const parentItem = menu.find((item) => item.name === parentName);
  if (!parentItem) return null;

  if (childName) {
    const subItem = parentItem.sub_menus?.find(
      (sub) => sub.name?.toLowerCase() === childName.toLowerCase()
    );
    return subItem?.permissions || null;
  }

  return parentItem.permissions || null;
};
